import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { PaymentSystemsPage } from './pages/PaymentSystemsPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/payment-settings`,
        element: <Outlet />,
        children: [{ index: true, element: <PaymentSystemsPage /> }],
    },
];
export default routes;
